import { useOne } from "@refinedev/core";
import { ISubscription } from "interfaces";

export interface AvcsFlatFeeInfo {
  amount: number | null;
  currency: string | null;
  subscriptionType: string | null;
}

export const useAvcsForSubscription = (
  subscriptionId: string | null | undefined,
): AvcsFlatFeeInfo => {
  const { result } = useOne<ISubscription>({
    resource: "subscription",
    id: subscriptionId ?? "",
    meta: { join: [{ field: "metadataAvcs" }] },
    queryOptions: { enabled: !!subscriptionId },
  });

  return {
    amount: result?.metadataAvcs?.annualFlatFeePerVessel ?? null,
    currency: result?.metadataAvcs?.currency ?? null,
    subscriptionType: result?.metadataAvcs?.subscriptionType ?? null,
  };
};
